(function ($) {
  "use strict";

  /*** Single Post page Scripts ***/

  const $postContent = $(document).find('#postContent');

  if ($postContent.length) {
    const $headings = $postContent.find('h2, h3, h4');

    if ($headings.length) {
      /* Heading data */
      let headings = [];

      $headings.each(function(index) {
        const $heading = $(this);
        const anchor = `heading-anchor-${++index}`;

        /* Add Heading data */
        headings.push({
          anchor: anchor,
          heading: $heading.html(),
        });

        /* Set anchors */
        let span = document.createElement('div');
        span.id = anchor;

        $heading.before(span);

      });

      const $postSummary      = $('#postSummary');
      const $postSummaryBody  = $('#postSummaryBody');

      if ($postSummary.length && $postSummaryBody.length) {
        headings.forEach(function(item) {
          let a 	= document.createElement('a');
          a.href = `#${item.anchor}`;
          a.innerHTML = item.heading;

          $postSummaryBody.append(a);
        });

        $postSummary.fadeIn();
      }
    }
  }


  $(document).on('click', '.js_hideReplies', function(e) {
    e.preventDefault();

    const $comment = $(this).closest('.comment');

    if ($comment.length) {
      const $children = $comment.children('.children');

      if ($children.length) {

        if ($children.is(':visible')) {
          $children.slideUp(200);
          $(this).text('Show replies');
          $comment.addClass('commentFolded');

        } else {
          $children.slideDown(200);
          $(this).text('Hide replies');
          $comment.removeClass('commentFolded');
        }

      }
    }
  });


  /*** LIKE Post Handler ***/
  const ajaxUrl       = hitech_ajax.ajaxurl;
  const likePost	    = hitech_ajax.likePost;
  const likePostNonce = hitech_ajax.likePostNonce;

  $(document).on('click', '.js_likeComment', function(e) {
    e.preventDefault();

    const $button = $(this);
    const commentID = $(this).attr('data-comment-id');

    if (!commentID) {
      return false;
    }

    const comID = Number.parseInt(commentID);

    let post_likes = JSON.parse(localStorage.getItem('hitech_post_likes'));
    post_likes = (Array.isArray(post_likes)) ? post_likes : [];

    let count = 'plus';
    let new_post_likes = [];

    if (post_likes.includes(comID)) {
      count = 'minus';
      new_post_likes = post_likes.filter(element => element !== comID);

    } else {
      post_likes.push(comID);
      new_post_likes = post_likes;
      count = 'plus';
    }

    localStorage.setItem('hitech_post_likes', JSON.stringify(new_post_likes));

    /* Async request */
    $.ajax({
      type: 'POST',
      url: ajaxUrl,
      data: {
        'action': likePost,
        'hitech_nonce': likePostNonce,
        'comment_id': commentID,
        'count': count,
      },
      beforeSend: function( xhr ) {
        //
      },
      success: function (result) {
        console.log(result);

        if (result.success && result.data !== undefined && result.data.rating !== undefined) {
          console.log(result.data.rating);
          $button.closest('.postComment_like').find('span').text(result.data.rating);
        }
      },
      fail: function (result) {
        // console.log('fail: ', result);
      }
    }).done(function (result){
      // console.log('Done', result);
    });

  });








})(jQuery);
